'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Col = function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Col);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Col.__proto__ || Object.getPrototypeOf(Col)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          xs = _this$props.xs,
          sm = _this$props.sm,
          md = _this$props.md,
          lg = _this$props.lg,
          xl = _this$props.xl,
          offset = _this$props.offset,
          pull = _this$props.pull,
          push = _this$props.push,
          debug = _this$props.debug,
          style = _this$props.style,
          otherProps = _objectWithoutProperties(_this$props, ['children', 'xs', 'sm', 'md', 'lg', 'xl', 'offset', 'pull', 'push', 'debug', 'style']);

      var theStyle = (0, _style2.default)({
        width: { xs: xs, sm: sm, md: md, lg: lg, xl: xl },
        offset: offset,
        pull: pull,
        push: push,
        debug: debug,
        screenClass: _this.state.screenClass,
        gutterWidth: _this.context.gutterWidth,
        moreStyle: style
      });
      return _react2.default.createElement(
        'div',
        _extends({ style: theStyle }, otherProps),
        children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Col;
}(_react2.default.Component);

Col.propTypes = {
  /**
   * Content of the column
   */
  children: _propTypes2.default.node,
  /**
   * The width of the column for screenclass `xs`, between 0 and 12
   */
  xs: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `sm`, between 0 and 12
   */
  sm: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `md`, between 0 and 12
   */
  md: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `lg`, between 0 and 12
   */
  lg: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `xl`, between 0 and 12
   */
  xl: _propTypes2.default.number,
  /**
   * The offset of this column for all screenclasses
   */
  offset: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
  * The amount this column is pushed to the right for all screenclasses
  */
  push: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
   * The amount this column is pulled to the left for all screenclasses
   */
  pull: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
   * Optional styling
   */
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  /**
   * Set to apply some debug styling
   */
  debug: _propTypes2.default.bool
};
Col.defaultProps = {
  children: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  offset: {},
  push: {},
  pull: {},
  style: {},
  debug: false
};
Col.contextTypes = {
  phone: _propTypes2.default.bool,
  tablet: _propTypes2.default.bool,
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
  gutterWidth: _propTypes2.default.number
};
exports.default = Col;


//////////////////
// WEBPACK FOOTER
// ./~/react-grid-system/build/grid/Col/index.js
// module id = 2776
// module chunks = 0